import { ChevronRightIcon } from '@zep-us/zus';
import { Trans, useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { cn } from '@zep/utils';
import { Button } from '../Button';
import { openLandingInquiryModal } from './LandingInquiryModal';
export const LandingCTA = () => {
  const {
    t
  } = useTranslation(['home']);
  const handleCtaClick = () => {
    logger.track('landing_inquiry');
    openLandingInquiryModal();
  };
  return <section className="w-full px-quiz-md py-quiz-md tablet:px-quiz-lg tablet:py-quiz-lg" data-sentry-component="LandingCTA" data-sentry-source-file="LandingCTA.tsx">
      <div className={cn('relative flex w-full flex-col tablet:flex-row', 'gap-quiz-xl items-center tablet:items-start justify-between', 'px-quiz-md py-quiz-2xl tablet:px-quiz-3xl tablet:py-quiz-4xl', 'rounded-quiz-lg', 'bg-gradient-to-r from-quiz-blue-400 to-quiz-purple-400')}>
        <div className="mx-auto flex w-full max-w-screen-xl flex-col items-center justify-between gap-quiz-xl tablet:flex-row tablet:items-start">
          <div className="flex flex-col gap-quiz-sm tablet:gap-quiz-md">
            <h2 className="w-full text-balance text-center text-quiz-heading-xl-extrabold text-quiz-inverse tablet:text-start tablet:text-quiz-heading-xl-extrabold lg:text-quiz-display-sm-extrabold">
              <Trans t={t} i18nKey="home:landing.chart.ctaTitle" components={{
              br: <br className="tablet:hidden" />
            }} data-sentry-element="Trans" data-sentry-source-file="LandingCTA.tsx" />
            </h2>
            <p className="w-full text-center text-quiz-body-sm-medium text-quiz-inverse tablet:text-start tablet:text-[19px] tablet:font-[400] lg:text-[20px]">
              {t('home:landing.chart.ctaDescription')}
            </p>
          </div>

          <div className="flex justify-end">
            <Button variant="contained" intent="alternative" size="sm" className={cn('flex h-[36px] tablet:h-[48px] tablet:min-w-[120px] items-center justify-center gap-quiz-3xs', 'bg-quiz-violet-50 text-quiz-strong', 'tablet:text-quiz-body-lg-semibold', 'hover:bg-quiz-violet-100', 'px-quiz-md')} onClick={handleCtaClick} data-sentry-element="Button" data-sentry-source-file="LandingCTA.tsx">
              {t('home:landing.chart.ctaButton')}
              <ChevronRightIcon className="size-[24px]" data-sentry-element="ChevronRightIcon" data-sentry-source-file="LandingCTA.tsx" />
            </Button>
          </div>
        </div>
      </div>
    </section>;
};